<template>
    <div class="desktop-menu flex space-x-8 3xl:space-x-10 items-center text-white font-light text-lg">
        <template v-for="(item, index) in menu" :key="index">            
            <template v-if="item.children.length > 0">
                <span class="relative cursor-pointer" @click="toggle(index, $event)">
                    {{ item.title }}
                </span>
                <OverlayPanel :key="index" :ref="'op-'+index" class="space-y-4">
                    <template v-for="(item, index) in item.children" :key="index">
                    <a 
                        class="block mb-4 hover:text-yellow transition-colors duration-300" 
                        :class="(item.is_current ? 'text-yellow font-bold' : '')"
                        :href="item.url"
                    >
                        {{ item.title }}
                    </a>
                    </template>
                </OverlayPanel>
            </template>
            <template v-else>
                <a 
                    class="relative hover:text-yellow transition-colors duration-300"
                    :class="(item.is_current ? 'text-yellow font-bold' : '')"
                    :href="item.url"
                >
                    {{ item.title }}
                </a>
            </template>
        </template>
    </div>
</template>
<script>

import OverlayPanel from 'primevue/overlaypanel/sfc';

export default {

    props: {
        'menu': {
            type: Object,
            required: true
        }
    },

    components: {
        OverlayPanel
    },

    methods: {
        toggle(id, event) {
            this.$refs['op-'+id].toggle(event)
        }
    }

}
</script>
